export const peterRabbitImages = [
  { id: 0, src: '/img/books/peter_rabbit_images/01.jpg' },
  { id: 1, src: '/img/books/peter_rabbit_images/02.jpg' },
  { id: 2, src: '/img/books/peter_rabbit_images/03.jpg' },
  { id: 3, src: '/img/books/peter_rabbit_images/04.jpg' },
  { id: 4, src: '/img/books/peter_rabbit_images/05.jpg' },
  { id: 5, src: '/img/books/peter_rabbit_images/06.jpg' },
  { id: 6, src: '/img/books/peter_rabbit_images/07.jpg' },
  { id: 7, src: '/img/books/peter_rabbit_images/08.jpg' },
  { id: 8, src: '/img/books/peter_rabbit_images/09.jpg' },
  { id: 9, src: '/img/books/peter_rabbit_images/010.jpg' },
  { id: 10, src: '/img/books/peter_rabbit_images/011.jpg' },
  { id: 11, src: '/img/books/peter_rabbit_images/012.jpg' },
  { id: 12, src: '/img/books/peter_rabbit_images/013.jpg' },
  { id: 13, src: '/img/books/peter_rabbit_images/014.jpg' },
  { id: 14, src: '/img/books/peter_rabbit_images/015.jpg' },
  { id: 15, src: '/img/books/peter_rabbit_images/016.jpg' },
  { id: 16, src: '/img/books/peter_rabbit_images/017.jpg' },
  { id: 17, src: '/img/books/peter_rabbit_images/018.jpg' },
  { id: 18, src: '/img/books/peter_rabbit_images/019.jpg' },
  { id: 19, src: '/img/books/peter_rabbit_images/020.jpg' },
  { id: 20, src: '/img/books/peter_rabbit_images/021.jpg' },
  { id: 21, src: '/img/books/peter_rabbit_images/022.jpg' },
  { id: 22, src: '/img/books/peter_rabbit_images/023.jpg' },
  { id: 23, src: '/img/books/peter_rabbit_images/024.jpg' },
  { id: 24, src: '/img/books/peter_rabbit_images/025.jpg' },
  { id: 25, src: '/img/books/peter_rabbit_images/026.jpg' },
]
